var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCloudArrowDown = function SvgIconCloudArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.02 5.574A6.5 6.5 0 0 1 20.2 15.9a1 1 0 0 0 1.6 1.2A8.5 8.5 0 1 0 7.478 8.041 6 6 0 0 0 6.75 8l.386.774L6.75 8a6.25 6.25 0 0 0 0 12.5H9a1 1 0 1 0 0-2H6.75a4.25 4.25 0 0 1-.011-8.5 8.5 8.5 0 0 0-.239 2 1 1 0 1 0 2 0 6.5 6.5 0 0 1 5.52-6.426"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 12a1 1 0 1 0-2 0v5.085l-1.47-1.47a1 1 0 0 0-1.415 1.414l3.162 3.162a.997.997 0 0 0 1.43.016l3.179-3.178a1 1 0 0 0-1.415-1.414l-1.471 1.471z"
  }))));
};
export default SvgIconCloudArrowDown;